import { requestSchool } from '@/axios';

const state = {
  classes: [],
};

const getters = {
  getClasses: state => state.classes,
  getFilteredClasses: state => (options) => {
    const {
      search = '',
      grade = '',
      name = '',
      location = '',
      timeframe = '',
    } = options;

    const searchVal = search.toLowerCase();
    const findBySearchStr = (cls) => {
      return cls.name.toLowerCase().includes(searchVal)
            || cls.grade.toLowerCase().includes(searchVal)
            || cls.location.toLowerCase().includes(searchVal)
            || cls.timeframe.toLowerCase().includes(searchVal);
    };

    return state.classes.filter((cls) => {
      return findBySearchStr(cls) && (name ? cls.name.toLowerCase().includes(name.toLowerCase()) : true)
            && (location ? cls.location.toLowerCase().includes(location.toLowerCase()) : true)
            && (grade ? cls.grade.toLowerCase().includes(grade.toLowerCase()) : true)
            && (timeframe ? cls.timeframe.toLowerCase().includes(timeframe.toLowerCase()) : true);
    });
  },
};

const actions = {
  loadSchoolClasses({ commit }) {
    return requestSchool.get('/class/child/all')
      .then((response) => {
        const { classes } = response.data;
        commit('SET_CLASSES', classes);
      });
  },
};

const mutations = {
  SET_CLASSES(state, classes) {
    state.classes = classes;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
